module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/studio-suns_access_01-0e5ba2249b6bd68c16cce3b5ec7b123a.jpg";